import React, { useEffect, useMemo, useState, useLayoutEffect } from "react";
import { createPortal } from "react-dom";

export function HalloweenPageNet({ anchorId , img, right = null, left = null,width,height }) {
    const container = useMemo(() => {
        if (typeof document === "undefined") return null;
        const el = document.createElement("div");
        el.setAttribute("data-holiday-overlay", "halloween");
        el.style.position = "absolute";
        el.style.pointerEvents = "none";
        el.style.zIndex = "2";
        return el;
    }, []);

    const [anchor, setAnchor] = useState(null);

    useEffect(() => {
        if (typeof document === "undefined") return;
        const tryFind = () => setAnchor(document.getElementById(anchorId));
        tryFind();
        const mo = new MutationObserver(tryFind);
        mo.observe(document.documentElement, { childList: true, subtree: true });
        return () => mo.disconnect();
    }, [anchorId]);

    useEffect(() => {
        if (!anchor || !container) return;
        anchor.appendChild(container);
        return () => {
            try { container.remove(); } catch {}
        };
    }, [anchor, container]);

    const OFFSET_X =  -1;
    const OFFSET_Y =  -2;
    const WIDTH    =  width;
    const HEIGHT   =  height;

    useLayoutEffect(() => {
        if (!container) return;
        container.style.top = `${OFFSET_Y}px`;
        container.style.right = right ?`${OFFSET_X}px` : 'auto';
        container.style.left = left ?`${OFFSET_X}px` : 'auto';
        container.style.bottom = "auto";
        container.style.width = `${WIDTH}px`;
        container.style.height = `${HEIGHT}px`;
    }, [container , HEIGHT, WIDTH, right, left, OFFSET_X, OFFSET_Y]);

    if (!container || !anchor) return null;

    return createPortal(
        <img
            src={img}
            alt=""
            width={WIDTH}
            height={HEIGHT}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            aria-hidden="true"
        />,
        container
    );
}
